import React from 'react'

const ErrorIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M9.20054 2.4255C8.5375 1.76246 7.4625 1.76246 6.79946 2.4255L1.99728 7.22768C1.33424 7.89072 1.33424 8.96572 1.99728 9.62877L6.79946 14.4309C7.4625 15.094 8.5375 15.094 9.20054 14.4309L14.0027 9.62877C14.6658 8.96572 14.6658 7.89072 14.0027 7.22768L9.20054 2.4255ZM7.24999 8.67823C7.24999 9.09244 7.58578 9.42823 7.99999 9.42823C8.41421 9.42823 8.74999 9.09244 8.74999 8.67823V5.17823C8.74999 4.76401 8.41421 4.42823 7.99999 4.42823C7.58578 4.42823 7.24999 4.76401 7.24999 5.17823V8.67823ZM7.24999 11.6782C7.24999 12.0924 7.58578 12.4282 7.99999 12.4282C8.41421 12.4282 8.74999 12.0924 8.74999 11.6782V11.1782C8.74999 10.764 8.41421 10.4282 7.99999 10.4282C7.58578 10.4282 7.24999 10.764 7.24999 11.1782V11.6782Z"
                  fill="#C53434"/>
        </svg>
    )
}

export default ErrorIcon;